module.exports = __webpack_public_path__ + "static/media/lockIcon.837502ee.svg";